/* Need a set timeout b/c the cart is rendered using AJAX */
setTimeout(() => {
  const associateInput = document.getElementById('associate-input');
  const checkoutBtn = document.querySelector('.ajax-cart__button-submit');
  const errorMsg = document.getElementById('associate-error');

  if (!associateInput || !checkoutBtn) return;

  function validate() {
    const isEmpty = associateInput.value.trim() === '';
    checkoutBtn.disabled = isEmpty;
    checkoutBtn.classList.toggle('disabled', isEmpty);
    if (errorMsg) {
      errorMsg.style.display = isEmpty ? 'block' : 'none';
    }
  }
  validate();
  associateInput.addEventListener('input', validate);
}, 1500);